import { expect, test } from "@benchristel/taste";

import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { createElement, render } from "preact";
import { useRef } from 'preact/compat'; // Change from 'preact' to 'preact/compat' for React compatibility
import { useEffect, useState } from "preact/hooks";

import useTimeout from "react-hook-timeout";
import { AdornedInput } from "./AdornedInput";
import { ButtonedInput } from "./ButtonedInput";
import { IconAnimationInDeciseconds } from "./experiments";
import { matches, uiTest } from "./lib/testUtilities";

export function TitleField({
  onSubmit,
  label,
  value: outerValue,
  placeholder,
  variant,
}: {
  onSubmit?: (value: string) => void
  label: string
  value: string | null
  placeholder: string
  variant?: string
}) {
  const { setTimeout } = useTimeout()
  const [innerValue, setInnerValue] = useState<string>(outerValue || "")
  const [hasValidationError, setHasValidationError] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>()
  useEffect(() => setInnerValue(outerValue || ""), [outerValue])
  const [isSubmitting, setisSubmitting] = useState<boolean>(false)

  function validate(): boolean {
    setHasValidationError(innerValue === "")
    return innerValue !== ""
  }

  function submitIfValid() {
    if (!validate()) return
    onSubmit?.(innerValue)
    setisSubmitting(true)
    setTimeout(() => setisSubmitting(false), IconAnimationInDeciseconds * 100)
  }

  const HeightOfInputSansSkeletonPaddingInPixels = 56
  return (
    <form
      style={{flexBasis:"100%"}}
      onSubmit={(event) => {
        event.preventDefault()
        submitIfValid()
      }}
    >
      <Stack p={0} direction="row" spacing={1}>
        <>
          {isNull(outerValue) && (
            <Skeleton
              animation="wave"
              width="100%"
              height={HeightOfInputSansSkeletonPaddingInPixels}
            />
          )}
          {isNull(outerValue) ||
            createElement(
              variant === "adorned" ? AdornedInput : ButtonedInput,
              {
                isSubmitting,
                label,
                hasValidationError,
                placeholder,
                setHasValidationError,
                setInnerValue,
                innerValue,
                inputRef,
                submitIfValid,
                onSubmit,
              },
            )}
        </>
      </Stack>
    </form>
  )
}

test("TitleField", {
  "renders a label": uiTest((el: HTMLDivElement) => {
    render(
      <TitleField value="bar" label="foo" onSubmit={() => {}} placeholder="" />,
      el,
    )
    expect(el.querySelector("label")!.innerText, matches, /foo/)
  }),
})

export function isNull(outerValue: string | null): boolean {
  return outerValue === null
}
